// scripts/seo-pages 가 만드는 정적 HTML 사전. SPA 라우트에 없어서 <Link> 가 아니라 <a href> 로 연결한다.
export const DICTIONARY_LINKS = {
  resources: { href: '/resources/', label: '교사 자료실 전체' },
  saenggibuExamples: { href: '/saenggibu/examples/', label: '행특·창체 예시 사전' },
  setukExamples: { href: '/curriculum/setuk/', label: '과목별 세특 예시' },
  saenggibuRules: { href: '/saenggibu/rules/', label: '생기부 기재 금지 사전' },
  saenggibuLimits: { href: '/saenggibu/limits/', label: '항목별 글자수 (2026)' },
  yearEndChecklist: { href: '/saenggibu/year-end-checklist/', label: '학년말 마감 점검표' },
  rubrics: { href: '/rubrics/', label: '채점 기준표 사전' },
  curriculum: { href: '/curriculum/', label: '성취기준 사전' },
  assessmentPlans: { href: '/assessment-plans/', label: '평가계획서 예시 사전' },
  schoolDocs: { href: '/school-docs/', label: '학교 문서 예시 사전' },
  assessmentNotice: { href: '/school-docs/assessment-notice/', label: '수행평가 안내 가정통신문' },
  winterVacation: { href: '/school-docs/winter-vacation/', label: '겨울방학 가정통신문' },
};
